<template>
  <div
    class="loading"
    v-if="isDisplay"
  >
    <b-spinner
      label="Spinning"
      variant="red"
    ></b-spinner>
  </div>
</template>

<script>
export default {
  name: 'loading',
  data: function () {
    return {
      isDisplay: false
    }
  },
  methods: {
    open () {
      this.isDisplay = true
      document.querySelector('body').style.overflow = 'hidden'
    },
    close () {
      this.isDisplay = false
      document.querySelector('body').style.overflow = ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: map-get($z-index, loading);
  background: rgba(0, 0, 0, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/common/Loading.vue